import { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateExceptionsControllerModule } from './controllers/TemplatesCreateExceptionsController';

export const TemplatesCreateExceptionView = angular
  .module('acme.view.application.templates.create.exceptions', [
    'ui.router',
    'ui.bootstrap',
    TemplatesCreateExceptionsControllerModule,
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.templates.create.exceptions',
      url: '/exceptions',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateExceptionsController',
          templateUrl: 'views/application/views/templates/create/exceptions/exceptions.tpl.html',
        },
      },
      data: {
        pageTitle: 'Event Template Exceptions',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.exceptions',
      url: '/exceptions',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateExceptionsController',
          templateUrl: 'views/application/views/templates/create/exceptions/exceptions.tpl.html',
        },
      },
      data: {
        pageTitle: 'Event Template Exceptions',
      },
    });
  }).name;
